'use client'

import Link from 'next/link'
import { ArrowRight } from 'lucide-react'

// Landing hero — MEMBERSHIP positioning, decluttered.
//
// Every element earns its place: chip (who), H1 (what), subline
// (why), CTAs (act), footer (urgency). Five things, not eight.
// Anything that felt like it needed more explanation (3 job-buckets,
// proof quote, promise recap) now lives in a section below — hero's
// job is JUST to make a cold visitor understand what BS is and click
// or scroll within 3 seconds.
export function LandingHero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center px-6 pt-24 pb-16">
      <div className="max-w-2xl w-full text-center">
        {/* Audience chip — names BOTH sub-audiences (licensing +
            licensed) so neither reads past thinking "not for me". */}
        <p className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.22em] text-bs-secondary-700 font-display font-semibold mb-8 px-3 py-1 rounded-full bg-bs-secondary-50 border border-bs-secondary-100">
          <span className="w-1.5 h-1.5 rounded-full bg-bs-secondary-500" />
          For licensing &amp; licensed therapists
        </p>

        <h1 className="font-display font-bold text-[46px] sm:text-[68px] leading-[1] tracking-tight text-gray-900 mb-8">
          <span className="block">
            The therapist{' '}
            <span className="relative inline-block italic text-bs-secondary-500">
              membership
              <svg
                aria-hidden
                viewBox="0 0 300 22"
                preserveAspectRatio="none"
                className="absolute left-0 -bottom-3 w-full h-3 text-bs-secondary-500 overflow-visible"
              >
                <path
                  d="M 4 12 C 50 5, 110 17, 165 10 S 245 6, 296 15"
                  stroke="currentColor"
                  strokeWidth="10"
                  strokeLinecap="round"
                  fill="none"
                />
              </svg>
            </span>
          </span>
          <span className="block mt-3">that has your back.</span>
        </h1>

        {/* Triptych — three parallel promises laid out as three
            distinct blocks (columns on desktop with subtle vertical
            dividers, stacked on mobile). Each phrase gets its own
            visual space so the eye reads them as separate things,
            not one comma-spliced sentence. */}
        <div className="max-w-3xl mx-auto mb-12 flex flex-col sm:flex-row items-stretch justify-center divide-y sm:divide-y-0 sm:divide-x divide-bs-secondary-200">
          <div className="flex-1 px-5 py-3 sm:py-1">
            <p className="text-[11px] uppercase tracking-[0.22em] text-bs-secondary-600 font-display font-semibold mb-1">
              Supervision
            </p>
            <p className="text-[15px] sm:text-[16px] text-gray-800 leading-snug font-display font-semibold">
              that grows you.
            </p>
          </div>
          <div className="flex-1 px-5 py-3 sm:py-1">
            <p className="text-[11px] uppercase tracking-[0.22em] text-bs-secondary-600 font-display font-semibold mb-1">
              Client referrals
            </p>
            <p className="text-[15px] sm:text-[16px] text-gray-800 leading-snug font-display font-semibold">
              that fill your caseload.
            </p>
          </div>
          <div className="flex-1 px-5 py-3 sm:py-1">
            <p className="text-[11px] uppercase tracking-[0.22em] text-bs-secondary-600 font-display font-semibold mb-1">
              A community
            </p>
            <p className="text-[15px] sm:text-[16px] text-gray-800 leading-snug font-display font-semibold">
              that actually shows up.
            </p>
          </div>
        </div>

        {/* Dual-button CTA row — Join is the primary (dark filled),
            Tour is a real secondary button (outlined + arrow) so it
            reads as an equal option, not a throwaway text-link. The
            tour is a first-class conversion path for visitors who
            aren't ready to commit but want the full narrative. */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            href="/between-sessions/tour/join"
            className="group inline-flex items-center gap-3 pl-6 pr-3 py-3 text-[15px] font-display font-semibold rounded-full bg-gray-900 hover:bg-black text-white shadow-[0_10px_28px_-10px_rgba(20,20,20,0.4)] hover:-translate-y-0.5 hover:shadow-[0_16px_36px_-12px_rgba(20,20,20,0.5)] transition-all duration-200"
          >
            Join Between Sessions
            <span className="w-8 h-8 rounded-full bg-white/15 group-hover:bg-white/25 flex items-center justify-center transition-colors">
              <ArrowRight className="w-4 h-4" />
            </span>
          </Link>
          <Link
            href="/between-sessions/tour"
            className="group inline-flex items-center gap-3 pl-6 pr-3 py-3 text-[15px] font-display font-semibold rounded-full bg-white text-gray-900 border-2 border-gray-900 hover:bg-gray-900 hover:text-white shadow-[0_6px_18px_-8px_rgba(20,20,20,0.2)] hover:-translate-y-0.5 hover:shadow-[0_14px_28px_-10px_rgba(20,20,20,0.35)] transition-all duration-200"
          >
            See how it works
            <span className="w-8 h-8 rounded-full bg-gray-900/10 group-hover:bg-white/25 flex items-center justify-center transition-colors">
              <ArrowRight className="w-4 h-4" />
            </span>
          </Link>
        </div>

      </div>
    </section>
  )
}
